import { ActionCreatorWithPayload, Store } from '@reduxjs/toolkit';

import { IncomingHttpHeaders } from 'http';

import { isMobile } from '@nocowanie/core/helpers';

import { environment } from '@app/environments/environment';

export const setMobile = ({
    userAgent,
    store,
    action,
}: {
    userAgent: IncomingHttpHeaders['user-agent'];
    store: Store;
    action: ActionCreatorWithPayload<any>;
}) => {
    const isMobileDevice = isMobile(userAgent);
    store.dispatch(action(isMobileDevice));
};

export const getAssetUrl = (path: string, baseUrl = environment.CEPH_URL): string => {
    const assetUrl = `${baseUrl}/${path}`;
    return assetUrl;
};

export type IdleCallbackId = number | ReturnType<typeof setTimeout>;

export const runWhenIdle = (callback: () => void): IdleCallbackId => {
    if ('requestIdleCallback' in window) {
        return window.requestIdleCallback(() => callback());
    } else {
        return setTimeout(callback, 1);
    }
};

export const cancelRunWhenIdle = (callbackId: IdleCallbackId) => {
    if ('requestIdleCallback' in window) {
        return cancelIdleCallback(callbackId as number);
    } else {
        return clearTimeout(callbackId);
    }
};
